<template>
  <div class="grid grid-cols-5 text-[var(--brand-primary)] bg-[var(--bg-surface)] border-t border-[var(--border-strong)] fixed bottom-0 left-0 right-0 text-sm">
    <RouterLink
      to="/"
      class="py-4 gap-1 flex justify-center flex-col items-center"
    >
      <Icon
        icon="ic:round-home"
        class="text-xl"
      />
      Inicio
    </RouterLink>
    <RouterLink
      class="py-4 gap-1 flex justify-center flex-col items-center"
      :to="{path: '/past'}"
    >
      <Icon
        icon="ic:round-receipt-long"
        class="text-xl"
      />
      Pasado
    </RouterLink>
    <RouterLink
      class="py-4 gap-1 flex justify-center flex-col items-center"
      :to="{path: '/present'}"
    >
      <Icon
        icon="ic:round-inbox"
        class="text-xl"
      />
      Presente
    </RouterLink>
    <RouterLink
      class="py-4 gap-1 flex justify-center flex-col items-center opacity-50"
      :to="{path: '/future'}"
    >
      <Icon
        icon="ic:round-savings"
        class="text-xl"
      />
      Futuro
    </RouterLink>
    <RouterLink
      class="py-4 gap-1 flex justify-center flex-col items-center"
      :to="{path: '/account'}"
    >
      <Icon
        icon="ic:round-person"
        class="text-xl"
      />
      Cuenta
    </RouterLink>
  </div>
</template>

<script>
</script>
